import { ITranslations } from '@inter-ikea-kompis/types';
import {
	SET_LOCALE,
	SET_STORE_ID,
	SET_ZIP_CODE,
	FETCH_LOCALIZATION_PENDING,
	FETCH_LOCALIZATION_SUCCESS,
	FETCH_LOCALIZATION_FAILURE,
	SET_WRITE_DIRECTION,
	LocalizationStateTypes,
	SET_KOMPIS_TRANSLATIONS,
} from './types';
import { Localization, WriteDirection } from 'sofa-reborn-react';

export function setLocale(value: string): LocalizationStateTypes {
	return {
		type: SET_LOCALE,
		value,
	};
}

export function setStoreId(value: string): LocalizationStateTypes {
	return {
		type: SET_STORE_ID,
		value,
	};
}

export function setZipCode(value: string | null, track: boolean): LocalizationStateTypes {
	return {
		type: SET_ZIP_CODE,
		value,
		track,
	};
}

export function setWriteDirection(value: WriteDirection): LocalizationStateTypes {
	return {
		type: SET_WRITE_DIRECTION,
		value,
	};
}

export function fetchLocalizationPending(): LocalizationStateTypes {
	return {
		type: FETCH_LOCALIZATION_PENDING,
	};
}

export function fetchLocalizationSuccess(
	localization: Localization,
	// eslint-disable-next-line @typescript-eslint/ban-types
	translations: {}
): LocalizationStateTypes {
	return {
		type: FETCH_LOCALIZATION_SUCCESS,
		localization,
		translations,
	};
}

export function fetchLocalizationFailure(): LocalizationStateTypes {
	return {
		type: FETCH_LOCALIZATION_FAILURE,
	};
}

export function setKompisTranslations(
	// eslint-disable-next-line @typescript-eslint/ban-types
	kompisTranslations: ITranslations
): LocalizationStateTypes {
	return {
		type: SET_KOMPIS_TRANSLATIONS,
		kompisTranslations,
	};
}
